"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduledReportsSelector = exports.cancelableScheduledReportsSelector = void 0;
var _reselect = require("reselect");
var scheduledReportsSelector = exports.scheduledReportsSelector = (0, _reselect.createSelector)(function (state) {
  return state.report.reports;
}, function (reports) {
  return reports.filter(function (report) {
    return report.ReportFrequency !== 'onDemand';
  });
});
var cancelableScheduledReportsSelector = exports.cancelableScheduledReportsSelector = (0, _reselect.createSelector)(scheduledReportsSelector, function (reports) {
  return reports.filter(function (report) {
    return report.RequestStatus !== 'UserCancelled' && report.RequestStatus !== 'SysRetired';
  });
});